export { default as GarageContentSlotMain } from './components/GarageContentSlotMain'
export { default as BOTGarageVehicles } from './components/BOTGarageVehicles'
export { default as VehicleDeleteModal } from './components/VehicleDeleteModal'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { withProps, lifecycle } from 'recompose'
import MyGaragePage from './MyGaragePage'
import { hideHorizontalScroll } from 'helpers/utils'
import { getUserVehicleDetails } from './selectors'
import { setGaragePageLayoutSequenceDesktop, setGaragePageLayoutSequenceLaptop, setGaragePageLayoutSequenceMobile } from './helpers'
import { showNewShopTiresModal } from '../NewShopTiresModal/actions'
import { GENERAL_SOURCE, YMME_NAME } from 'constant'
import { getCurrentStoreNumber } from 'selectors/getCurrentStore'

const mapDispatchToProps = {
  showNewShopTiresModal
}

const mapStateToProps = (state) => {
  const userVehicleDetails = getUserVehicleDetails(state)

  return {
    noOfVehicles: userVehicleDetails && userVehicleDetails.noOfVehicles,
    userVehicle: userVehicleDetails && userVehicleDetails.userVehicle,
    storeNumber: getCurrentStoreNumber(state)
  }
}

const withInitializationAndUpdating = lifecycle({
  componentDidMount() {
    const html = document.querySelector('html')

    hideHorizontalScroll(html)
  }
})

const withGridTemplateAreaLayouts = withProps(({
  noOfVehicles,
  showNewShopTiresModal
}) => ({
  addNewVehicle: () => showNewShopTiresModal({
    isOnlyVehicle: true,
    ymmeName: YMME_NAME,
    withShowConfirmTireSizeModal: true,
    source: GENERAL_SOURCE
  }),
  gridTemplateAreas: {
    garageGridNoVehicles: {
      desktop: setGaragePageLayoutSequenceDesktop(0),
      laptop: setGaragePageLayoutSequenceLaptop(0),
      mobile: setGaragePageLayoutSequenceMobile(0)
    },
    garageGridWithVehicles: {
      desktop: setGaragePageLayoutSequenceDesktop(noOfVehicles),
      laptop: setGaragePageLayoutSequenceLaptop(noOfVehicles),
      mobile: setGaragePageLayoutSequenceMobile(noOfVehicles)
    }
  }
}))

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withInitializationAndUpdating,
  withGridTemplateAreaLayouts
)(MyGaragePage)
